module.exports = __webpack_public_path__ + "media/images/categories/carousel/government-and-law-2eb39d8298e5d1f151857c887bc2c5aa.jpg";